export default "__VITE_ASSET__d7b3ba4f__"